export function SettingsPanel() {
  return (
    <section className="tactical-card obc-admin__builder">
      <div className="obc-admin__panel-head">
        <h2>Admin Settings</h2>
        <span>Permissions and workflow rules</span>
      </div>
      <div className="obc-admin__settings-grid">
        <article><strong>Bidder verification</strong><span>Require saved card before bidding.</span></article>
        <article><strong>Anti-snipe extension</strong><span>Extend countdown when bids land near close.</span></article>
        <article><strong>Unpaid penalty</strong><span>Trigger reminders and relist unpaid wins.</span></article>
      </div>
    </section>
  )
}

export function AdminSettingsModule() {
  return <SettingsPanel />
}
